import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: { padding: theme.spacing(3) },
  buttons: { marginTop: theme.spacing(2) },
  login: { textAlign: 'center' },
}));
